export function todayFaDate(): string {
  const formatted = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
  return formatted.replace(/[^\d/۰-۹]/g, '');
}

export function toNumber(value: string): number {
  const n = Number((value || '').replace(/,/g, '').replace(/\D/g, ''));
  return Number.isFinite(n) ? n : 0;
}

export function formatThousands(value: string): string {
  const n = toNumber(value);
  if (!n) return '';
  return n.toLocaleString('en-US');
}

export function formatOptionalAmount(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(Number(n))) return '';
  return Number(n).toLocaleString('en-US');
}
